import { MAX_LOCATION_NAME, normaliseLocationName, } from "./location.js";
/**
 * What a new household starts with.
 *
 * Enough to be usable immediately, few enough that the list is not a wall.
 * Everything else is the user's to add — most households have exactly one
 * fridge and two or three cupboards worth naming.
 */
export const DEFAULT_STORAGES = [
    { name: "Fridge", kind: "fridge" },
    { name: "Freezer", kind: "freezer" },
    { name: "Cupboard", kind: "pantry" },
    { name: "Counter", kind: "counter" },
];
export const MAX_STORAGE_NAME = MAX_LOCATION_NAME;
export function validateStorageName(raw) {
    const name = normaliseLocationName(raw);
    if (name.length === 0)
        return "empty";
    if (name.length > MAX_STORAGE_NAME)
        return "too_long";
    return null;
}
export function normaliseStorageName(raw) {
    return normaliseLocationName(raw);
}
/**
 * How a storage place reads on an item row.
 *
 * Falls back to the generic kind when the place has been deleted, so an old
 * item degrades to "Pantry" rather than to a blank or a dangling id.
 */
export function storageLabel(storageId, places, fallbackKind, labels) {
    const found = storageId ? places.find((p) => p.id === storageId) : undefined;
    return found?.name ?? labels[fallbackKind];
}
//# sourceMappingURL=storage.js.map